import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import plugVueEngine from '../../../../../Widgets/DataPainterWidget/PlugVueWidget/PlugVueEngine';
import { PV_SECTION_FALLBACK, PV_TARGET_ALL } from '../../../../../Widgets/DataPainterWidget/PlugVueWidget/plugVueConst';
import commandEngine from './CommandEngine';
import { CMD_PLUGVUE_REGISTRY_KEY, META_TYPE, META_VER } from './plugVueCommandRegisteryType';

/**
 * Registers the /plugs command — multi-instance, target = section name or 'all'.
 * /plugs → all sections, /plugs Office → only that section. params is a getter so the
 * dropdown reflects the sections loaded at the moment the user types.
 */
export function registerPlugVueCommand() {
    commandEngine.register('/plugs', {
        hint: '[section] — smart plug overview, e.g. /plugs or /plugs Office',
        get params() {
            return [
                {
                    name: 'section',
                    options: plugVueEngine.getSections().map((s) => ({ label: s, value: s })),
                },
            ];
        },
        handler: (params) => {
            const [section] = params ?? [];
            cardPainterManager.openCard(CMD_PLUGVUE_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: resolveTarget(section) });
        },
    });
}

/**
 * Case-insensitive section match — /plugs office opens the 'Office' window (same target as /plugs Office).
 * @param {string|undefined} section
 * @returns {string} known section name with BE casing, the input as-is when unknown, or PV_TARGET_ALL
 */
function resolveTarget(section) {
    const term = section?.trim();
    if (!term || term.toLowerCase() === PV_TARGET_ALL) return PV_TARGET_ALL;
    const known = [...plugVueEngine.getSections(), PV_SECTION_FALLBACK];
    return known.find((s) => s.toLowerCase() === term.toLowerCase()) ?? term;
}
